import { render, staticRenderFns } from "./Default.vue?vue&type=template&id=5643e4f4&"
import script from "./Default.vue?vue&type=script&lang=js&"
export * from "./Default.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/style.css?vue&type=style&index=0&lang=css&"
import style1 from "../../assets/css/iransans/fontiran.css?vue&type=style&index=1&lang=css&"
import style2 from "../../assets/css/font-awesome.css?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports